/* global _DEBUG */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { captureException } from '@sentry/browser';

export class ErrorBoundary extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  state = {
    error: false,
  };

  componentDidCatch(error) {
    this.setState(() => ({
      error: true,
    }));

    if (_DEBUG) {
      captureException(error);
    }

    // eslint-disable-next-line no-console
    console.error(error);
  }

  render() {
    const { error } = this.state;
    if (error) {
      return <span>Oops! There was an error rendering this component.</span>;
    }
    const { children } = this.props;
    return children;
  }
}

export const catchErrors = (Component) => (props) => (
  <ErrorBoundary>
    <Component {...props} />
  </ErrorBoundary>
);
